var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#F7A246"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.5C16.0711 21.5 17.9461 20.6605 19.3033 19.3033L18.2426 18.2426C17.1569 19.3284 15.6569 20 14 20C10.6863 20 8 17.3137 8 14C8 10.6863 10.6863 8 14 8C16.04 8 17.8421 9.01805 18.9262 10.5738L17 12.5H21.5V8L20.0003 9.49969C18.632 7.67819 16.4536 6.5 14 6.5C9.85786 6.5 6.5 9.85786 6.5 14C6.5 18.1421 9.85786 21.5 14 21.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.5C16.0711 21.5 17.9461 20.6605 19.3033 19.3033L18.2426 18.2426C17.1569 19.3284 15.6569 20 14 20C10.6863 20 8 17.3137 8 14C8 10.6863 10.6863 8 14 8C16.04 8 17.8421 9.01805 18.9262 10.5738L17 12.5H21.5V8L20.0003 9.49969C18.632 7.67819 16.4536 6.5 14 6.5C9.85786 6.5 6.5 9.85786 6.5 14C6.5 18.1421 9.85786 21.5 14 21.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.c8e40dc12e5d7701e485a2cfa240cd3d.svg";
export { ForwardRef as ReactComponent };